module.exports = __webpack_public_path__ + "img/5C5C04_BDBD0D_939304_A4A404-256px.f1b594fc.png";